var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 3C13 2.44772 12.5523 2 12 2C11.4477 2 11 2.44772 11 3C11 3.55228 11.4477 4 12 4C12.5523 4 13 3.55228 13 3Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 6.5C21 8.433 19.433 10 17.5 10C15.567 10 14 8.433 14 6.5C14 4.567 15.567 3 17.5 3C19.433 3 21 4.567 21 6.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7126 3.23557C13.1681 3.0821 12.5936 3 12 3C8.52063 3 5.70002 5.82061 5.70002 9.3V11.0504C5.70002 11.6737 5.54497 12.2871 5.24884 12.8355L4.04045 15.0733C3.47924 16.1126 3.92166 17.4096 5.00098 17.8893C9.45687 19.8697 14.5432 19.8697 18.9991 17.8893C20.0784 17.4096 20.5208 16.1126 19.9596 15.0733L18.7512 12.8355C18.516 12.3999 18.3697 11.9232 18.3196 11.4332C18.0529 11.4771 17.7791 11.5 17.5 11.5C14.7386 11.5 12.5 9.26142 12.5 6.5C12.5 5.25239 12.957 4.1115 13.7126 3.23557Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98682 20.6309C9.72005 21.47 10.7981 22.0001 12 22.0001C13.2019 22.0001 14.28 21.47 15.0132 20.6309C13.0178 20.956 10.9822 20.956 8.98682 20.6309Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationAlt1);
export default __webpack_public_path__ + "static/media/notification-alt-1.c9c59988eef7f1ae387c0e0ae7dad105.svg";
export { ForwardRef as ReactComponent };